import ProjectsByRole from "@/components/projects/ProjectsByRole";
import AppButton from "@/components/structure/AppButton";
import SimplePage from "@/components/structure/SimplePage";
import { useAuth } from "@/contexts/AuthContext";

export default function Home() {
  const { isAuthenticated, user } = useAuth();

  return (
    <SimplePage className="flex-1">
      <ProjectsByRole />

      <div className="mt-6">
        {isAuthenticated && user?.isProjectsAdmin && (
          <AppButton variant="primary" href={"/projects/new"}>
            Create New Project
          </AppButton>
        )}
      </div>
    </SimplePage>
  );
}
